import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { AdminApi, agentIdentifier, localized } from "@/api";
import type { AgentState } from "@/types";

export function AgentList({
  agents,
  selectedId,
  onSelect,
  api,
}: {
  agents: AgentState[];
  selectedId: string;
  onSelect: (id: string) => void;
  api: AdminApi;
}) {
  return (
    <div className="grid gap-1 pt-3">
      {agents.map((agent) => {
        const id = agentIdentifier(agent);
        const selected = selectedId === id;
        return (
          <button
            key={id}
            className={cn(
              "flex w-full cursor-pointer items-center gap-3 rounded-lg border-0 bg-transparent p-3 text-left text-foreground",
              selected && "bg-accent text-accent-foreground",
            )}
            onClick={() => onSelect(id)}
          >
            <img
              className="size-10.5 shrink-0 rounded-full border border-border object-cover"
              src={api.absoluteUrl(agent.template.agent_avatar_url)}
              alt=""
              onError={(event) => {
                event.currentTarget.style.display = "none";
              }}
            />
            <span className="grid min-w-0 gap-0.75">
              <strong>{localized(agent.template.title, agent.template.kind)}</strong>
              <small className="text-xs text-muted-foreground">{agent.template.kind}</small>
              <small className="text-xs text-muted-foreground">{localized(agent.template.phrase, "")}</small>
            </span>
            {agent.template.is_active
              ? <Check className="ml-auto size-4.5 text-status-active" />
              : <span className="ml-auto grid size-5 place-items-center rounded-full border border-foreground-subtle text-[11px]">Ⅱ</span>}
          </button>
        );
      })}
    </div>
  );
}
